import React from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import FlatsFilter from "Components/Filters/FlatsFilter";
import HousesFilter from "Components/Filters/HousesFilter";
import LandsFilter from "Components/Filters/LandsFilter";
import CommercialsFilter from "./Components/Filters/CommercialsFilter";
import OthersFilter from "./Components/Filters/OthersFilter";

import { Provider } from "ContextStore";
import BlocksNav from "Components/BlocksNav";
import {
    FlatOffer,
    FlatsFilter as FlatsFilterType,
    HouseOffer,
    HousesFilter as HousesFilterType,
    LandsFilter as LandsFilterType,
    CommercialFilter as CommercialFilterType,
    OthersFilter as OthersFilterType,
    LandOffer,
    FilterTypes,
    CommercialOffer,
    BrokerOffer,
} from "./Types";
import List from "Components/Lists/List";
import routes from "./routes";
import { Helmet } from "react-helmet";

const App = (): JSX.Element => {
    const location = useLocation();
    const titleSuffix = ` - ${window.rmxo_pageTitle}`;
    return (
        <Provider>
            <Helmet>
                <meta property="og:site_name" content={window.rmxo_pageTitle} />
                <meta property="og:url" content={window.rmxo_indexPage + location.pathname} />
            </Helmet>
            <Switch>
                <Route exact path={`/${routes.flats}`}>
                    <Helmet>
                        <title>Byty na prodej a k pronájmu{titleSuffix}</title>
                    </Helmet>
                    <FlatsFilter />
                </Route>
                <Route exact path={`/${routes.houses}`}>
                    <Helmet>
                        <title>Domy na prodej a k pronájmu{titleSuffix}</title>
                    </Helmet>
                    <HousesFilter />
                </Route>
                <Route exact path={`/${routes.lands}`}>
                    <Helmet>
                        <title>Pozemky na prodej a k pronájmu{titleSuffix}</title>
                    </Helmet>
                    <LandsFilter />
                </Route>
                <Route exact path={`/${routes.commercial}`}>
                    <Helmet>
                        <title>Komerční nemovitosti na prodej a k pronájmu{titleSuffix}</title>
                    </Helmet>
                    <CommercialsFilter />
                </Route>
                <Route exact path={`/${routes.other}`}>
                    <OthersFilter />
                </Route>
                <Route exact path="/" component={BlocksNav} />
            </Switch>
        </Provider>
    );
};

export default App;
